// frontend/src/slices/inventaireCollecteApiSlice.js
import { apiSlice } from "./apiSlice";

const BASE = "/api/inventaires-collecte";

export const inventaireCollecteApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Récap de la session ACTIVE, regroupé par zone, avec écarts
    // (quantité bipée − stock théorique S1+S2+S3+S4+S5).
    getRecapZones: builder.query({
      query: (entrepriseId) => `${BASE}/recap-zones/${entrepriseId}`,
      providesTags: ["InventaireZone"],
    }),

    // Résumé des écarts PAR ZONE, sans le détail des lignes. Endpoint séparé
    // plutôt qu'un paramètre sur getRecapZones : les deux réponses n'ont ni la
    // même forme ni le même poids, les mélanger dans une même entrée de cache
    // ferait servir l'une à la place de l'autre.
    getRecapZonesResume: builder.query({
      query: (entrepriseId) =>
        `${BASE}/recap-zones/${entrepriseId}?resume=1`,
      providesTags: ["InventaireZone"],
    }),

    // ─── Suivi bipage ────────────────────────────────────────────────────
    // Qui a bipé quelle zone, quand, combien de temps, avec quelles
    // observations (agent sur le collecteur + suivi depuis le web).
    getSuiviBipage: builder.query({
      query: ({ entrepriseId, session, statut, search }) => ({
        url: `${BASE}/suivi-bipage/${entrepriseId}`,
        params: {
          ...(session && { session }),
          ...(statut && { statut }),
          ...(search && { search }),
        },
      }),
      providesTags: ["SuiviBipage"],
    }),

    // ─── Agents de l'inventaire ──────────────────────────────────────────
    // Une ligne par personne ayant travaillé sur l'inventaire : zones bipées
    // au collecteur ET coupons détachables rapportés.
    getAgentsInventaire: builder.query({
      query: ({ entrepriseId, session }) => ({
        url: `${BASE}/agents-inventaire/${entrepriseId}`,
        params: { ...(session && { session }) },
      }),
      providesTags: ["SuiviBipage"],
    }),

    updateObservationBipage: builder.mutation({
      query: ({ entrepriseId, id, observation }) => ({
        url: `${BASE}/suivi-bipage/${entrepriseId}/${id}/observation`,
        method: "PATCH",
        body: { observation },
      }),
      invalidatesTags: ["SuiviBipage"],
    }),
  }),
});

export const {
  useGetRecapZonesQuery,
  useGetRecapZonesResumeQuery,
  useGetSuiviBipageQuery,
  useGetAgentsInventaireQuery,
  useUpdateObservationBipageMutation,
} = inventaireCollecteApiSlice;
